import {
  useComparison,
  type ComparisonResult,
  type ComparisonSpec
} from "./useComparison";
import type { CompanyComparison, CompareToSelection } from "./types";

export interface UseCompaniesComparisonReturn
  extends ComparisonResult<CompanyComparison> {}

// Module-level so its identity is stable — `useComparison` keys memos on it.
const COMPANIES_SPEC: ComparisonSpec<CompanyComparison> = {
  endpoint: "contracts/companies/compare",
  idsField: "companyIds",
  rowsField: "companies",
  readRowId: (row) => row.companyId,
  // Unlike the contract grain, this endpoint reports ids it cannot resolve
  // instead of dropping them — a request naming only unknown ids would
  // otherwise answer 200 with an empty list, indistinguishable from "nothing
  // moved".
  notFoundField: "notFoundCompanyIds"
};

/**
 * Per-company movement for the rows currently on screen.
 *
 * Served by contractsapi rather than companiesapi: a company's figures are
 * summed from its contracts, so the snapshots the comparison reads live beside
 * the contract ones.
 */
export const useCompaniesComparison = (
  companyIds: readonly string[],
  selection: CompareToSelection | undefined,
  enabled: boolean = true
): UseCompaniesComparisonReturn =>
  useComparison(companyIds, selection, enabled, COMPANIES_SPEC);
